import React from 'react';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Skeleton } from '@mui/material';
import { addPointsInText } from '../../../../helpers/app';
import { images } from '../../../../constants/images';
import { PublicationMobilePriceIndicatorProps } from '../../interfaces';
import styles from '../../publicationDetailMobile.module.scss';



const PublicationMobilePriceIndicator: React.FC<PublicationMobilePriceIndicatorProps> = ({
    hasValidSuggestedPricesPublication,
    getPriceCategoryPublication,
    getIndicatorPositionPublication,
    getPriceDifferenceMessage,
    publication,
    brand,
    truncateText
}) => {
    const addPointsInText = (text: string) => {
        if (!text) return '';
        return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    // No mostrar si es oportunidad
    if (publication?.opportunity === true) {
        return null;
    }

    return (
        <div className={styles.priceIndicatorContainer}>
            {hasValidSuggestedPricesPublication && (
                <div className={styles.marketPriceSection}>
                    <h3>Precios del mercado</h3>
                    <div className={styles.marketPriceInfo}>
                        <div className={styles.priceBar}>
                            <div className={styles.priceBarInner}>
                                <div
                                    className={`${styles.priceTag} ${getPriceCategoryPublication() !== "good" && getPriceCategoryPublication() !== "fair" ? styles.elevado : ""}`}
                                    style={{ left: `${getIndicatorPositionPublication()}%` }}
                                >
                                    <p className={styles.actualPrice}>${addPointsInText(publication?.price)}</p>
                                    {(getPriceCategoryPublication() === "good" || getPriceCategoryPublication() === "fair") && (
                                        <div className={styles.priceCategory}>
                                            <img
                                                src={
                                                    getPriceCategoryPublication() === "good"
                                                        ? images.checkVerde
                                                        : images.checkAmarillo
                                                }
                                                alt="Indicador de precio"
                                                title="Indicador de precio"
                                                className={styles.priceIcon}
                                                style={{ width: '18px', height: '18px' }}
                                            />
                                            {getPriceCategoryPublication() === "good"
                                                ? "Buen precio"
                                                : "Precio justo"}
                                        </div>
                                    )}
                                </div>

                                <div className={styles.pricePointer} style={{ left: `${getIndicatorPositionPublication()}%` }} />
                            </div>
                        </div>
                        <div className={styles.suggestedPriceDisplay}>
                            <h3>${addPointsInText(publication?.vehicle_data?.suggested_price?.suggested_price || publication?.suggested_prices?.sale)}</h3>
                            <p>Precio Sugerido</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PublicationMobilePriceIndicator;
